import { useState } from 'react';

const MobileNav = ({ items = [] }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="md:hidden" style={{ position: 'relative' }}>
      <button onClick={() => setOpen(!open)} data-testid="mobile-menu-btn"
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8 }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round">
          {open
            ? (<><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>)
            : (<><line x1="3" y1="7" x2="21" y2="7"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="17" x2="21" y2="17"/></>)}
        </svg>
      </button>
      {open && (
        <div data-testid="mobile-menu" style={{
          position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 200,
          backgroundColor: '#0a0a0a', border: '1px solid rgba(212,175,55,0.25)',
          borderRadius: 12, overflow: 'hidden', minWidth: 220,
          boxShadow: '0 12px 40px rgba(0,0,0,0.8)',
        }}>
          {items.map((item, i) => (
            <button key={i} onClick={() => { setOpen(false); item.action(); }}
              data-testid={`mobile-nav-${i}`}
              style={{
                width: '100%', display: 'block', textAlign: 'left',
                background: 'none', border: 'none',
                borderBottom: i < items.length - 1 ? '1px solid rgba(212,175,55,0.1)' : 'none',
                padding: '14px 20px', cursor: 'pointer',
                fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37', letterSpacing: 0.5,
              }}>
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileNav;
